import { Component, OnInit } from '@angular/core';
import { ToastService } from '../../services/toast.service';
import { Subscription, Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css']
})
export class ToastComponent implements OnInit {

  private subscription: Subscription;
  toasts: Array<any> = [];
  private timer: Observable<any>;
 

  constructor(private toastService: ToastService) {   
    // subscribe to alert messages
    this.subscription = toastService.getMessage().subscribe(message => {
      if (message)
        {
          document.body.style.overflow='hidden';
          this.toasts.push(message);
        }
    });
  }
  ngOnInit() {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  
  closeMessage($key: number) {
    this.toasts.splice($key, 1);
    this.toastService.onClose();
    if(this.toasts.length==0)document.body.style.overflow='auto';
  }
}
